// Internal dependencies
import { TEMPLATES_TYPES } from './templatesTypes';
import { ContentIconSG, EmailIconSG, GoogleIconSG, IdeaIconSG, FacebookIconSG, InstagramIconSG, NaverIconSG, LinkedInIconSG, YahooIconSG, YoutubeIconSG, EditInCircleIconSG, SummarizeContentIconSG, RunCommandIconSG, } from '../components/icons';
/** Templates menu */
export const TEMPLATES_MENU = [
    {
        name: TEMPLATES_TYPES.GOOGLE_ADS_HEADLINE,
        subtitle: 'Generate headline for Google search ads',
        Icon: GoogleIconSG,
        iconAlt: 'Google Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.GOOGLE_ADS_DESCRIPTION,
        subtitle: 'Generate description for search ads',
        Icon: GoogleIconSG,
        iconAlt: 'Google Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.YOUTUBE_TITLE_DESCRIPTION,
        subtitle: 'Write title and description that increase engagement',
        Icon: YoutubeIconSG,
        iconAlt: 'Youtube Icon',
        category: ['All', 'Video'],
    },
    {
        name: TEMPLATES_TYPES.FACEBOOK_ADS,
        subtitle: 'Generate ads targeting the right audience on Facebook',
        Icon: FacebookIconSG,
        iconAlt: 'Facebook Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.FACEBOOK_ADS_DESCRIPTION,
        subtitle: 'Generate ads targeting the right audience on Facebook',
        Icon: FacebookIconSG,
        iconAlt: 'Facebook Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.FACEBOOK_POST_CONTENT,
        subtitle: 'Generate engaging post for your audience on Facebook',
        Icon: FacebookIconSG,
        iconAlt: 'Facebook Icon',
        category: ['All', 'Social Media'],
    },
    {
        name: TEMPLATES_TYPES.INSTAGRAM_ADS,
        subtitle: 'Generate ads targeting the right audience on Instagram',
        Icon: InstagramIconSG,
        iconAlt: 'Instagram Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.INSTAGRAM_POST_CONTENT,
        subtitle: 'Generate engaging post for your audience on Instagram',
        Icon: InstagramIconSG,
        iconAlt: 'Instagram Icon',
        category: ['All', 'Social Media'],
    },
    {
        name: TEMPLATES_TYPES.NAVER_ADS,
        subtitle: 'Generate high ROI copies for Naver Ads',
        Icon: NaverIconSG,
        iconAlt: 'Naver Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.NAVER_ADS_DESCRIPTION,
        subtitle: 'Generate high ROI copies for Naver Ads',
        Icon: NaverIconSG,
        iconAlt: 'Naver Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.YAHOO_ADS,
        subtitle: 'Generate high ROI copies for Yahoo Search Ads',
        Icon: YahooIconSG,
        iconAlt: 'Yahoo Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.YAHOO_ADS_DESCRIPTION,
        subtitle: 'Generate high ROI copies for Yahoo Search Ads',
        Icon: YahooIconSG,
        iconAlt: 'Yahoo Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.LINKEDIN_ADS,
        subtitle: 'Generate ads targeting the right audience on LinkedIn',
        Icon: LinkedInIconSG,
        iconAlt: 'LinkedIn Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.LINKEDIN_ADS_DESCRIPTION,
        subtitle: 'Generate ads targeting the right audience on LinkedIn',
        Icon: LinkedInIconSG,
        iconAlt: 'LinkedIn Icon',
        category: ['All', 'Ads'],
    },
    {
        name: TEMPLATES_TYPES.LINKEDIN_POST_CONTENT,
        subtitle: 'Generate engaging post for your audience on LinkedIn',
        Icon: LinkedInIconSG,
        iconAlt: 'LinkedIn Icon',
        category: ['All', 'Social Media'],
    },
    {
        name: TEMPLATES_TYPES.CONTENT_OUTLINE,
        subtitle: 'Generate content outline based on your topic',
        Icon: ContentIconSG,
        iconAlt: 'Content Icon',
        category: ['All', 'Website'],
    },
    {
        name: TEMPLATES_TYPES.CONTENT_BODY,
        subtitle: 'Generate a paragraph based on your topic',
        Icon: ContentIconSG,
        iconAlt: 'Content Icon',
        category: ['All', 'Website'],
    },
    {
        name: TEMPLATES_TYPES.CONTENT_TITLE_DESCRIPTION,
        subtitle: 'Generate optimised <title> & <description>',
        Icon: ContentIconSG,
        iconAlt: 'Content Icon',
        category: ['All', 'Website'],
    },
    {
        name: TEMPLATES_TYPES.CONTENT_IDEAS,
        subtitle: 'Generate ideas relevant to your topic and keywords',
        Icon: IdeaIconSG,
        iconAlt: 'Idea Icon',
        category: ['All', 'Website', 'Ads', 'Social Media', 'Email', 'Video'],
    },
    {
        name: TEMPLATES_TYPES.EMAIL_CONTENT,
        subtitle: '1-click for onboarding, follow-up, and more emails',
        Icon: EmailIconSG,
        iconAlt: 'Email Icon',
        category: ['All', 'Website', 'Ads', 'Social Media', 'Email', 'Video'],
    },
    {
        name: TEMPLATES_TYPES.JAPANESE_EMAIL_CONTENT,
        subtitle: '1-click to create a professional email in Japanese',
        Icon: EmailIconSG,
        iconAlt: 'Email Icon',
        category: ['All', 'Website', 'Ads', 'Social Media', 'Email', 'Video'],
    },
    {
        name: TEMPLATES_TYPES.CONTENT_REWRITER,
        subtitle: '1-click to improve your content quality',
        Icon: EditInCircleIconSG,
        iconAlt: 'Edit Icon',
        category: ['All', 'Website', 'Ads', 'Social Media', 'Email', 'Video'],
    },
    {
        name: TEMPLATES_TYPES.WRITE_FOR_ME,
        subtitle: 'Share your great ideas. We will do the rest for you',
        Icon: EditInCircleIconSG,
        iconAlt: 'Edit Icon',
        category: ['All', 'Website', 'Ads', 'Social Media', 'Email', 'Video'],
    },
    {
        name: TEMPLATES_TYPES.EXPAND_TEXT,
        subtitle: 'Turn a short sentence into a longer and engaging one',
        Icon: EditInCircleIconSG,
        iconAlt: 'Edit Icon',
        category: ['All', 'Website', 'Ads', 'Social Media', 'Email', 'Video'],
    },
    {
        name: TEMPLATES_TYPES.SUMMARIZE,
        subtitle: 'Extract the key takeaways from lengthy content',
        Icon: SummarizeContentIconSG,
        iconAlt: 'Summarize Content Icon',
        category: ['All', 'Website'],
    },
    {
        name: TEMPLATES_TYPES.RUN_COMMAND,
        subtitle: 'Make a request to write about anything',
        Icon: RunCommandIconSG,
        iconAlt: 'Run Command Icon',
        category: ['All', 'Website'],
    },
];
